import { render, staticRenderFns } from "./schoolHome.vue?vue&type=template&id=094a70f2&scoped=true&"
import script from "./schoolHome.vue?vue&type=script&lang=js&"
export * from "./schoolHome.vue?vue&type=script&lang=js&"
import style0 from "./schoolHome.vue?vue&type=style&index=0&id=094a70f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094a70f2",
  null
  
)

export default component.exports